import { PricingCopilotMatrixOverviewSuggestion } from './pricing-copilot-matrix-overview-suggestion';
import { ViewSupplierDashboard } from './view-supplier-dashboard';
import { SupplierDashboardOverviewTodaySnapshot } from './supplier-dashboard-overview-today-snapshot';

export class SupplierDashboardOverview {
	public closingSessions: ViewSupplierDashboard[];
	public newestSessions: ViewSupplierDashboard[];
	public pricingCopilotSuggestion: PricingCopilotMatrixOverviewSuggestion;
	public pinnedSessions: ViewSupplierDashboard[];
	public todaySnapshot: SupplierDashboardOverviewTodaySnapshot;

	constructor(supplierDashboardOverview: SupplierDashboardOverview) {
		Object.assign(this, supplierDashboardOverview);

		this.closingSessions = this.closingSessions.map(r => new ViewSupplierDashboard(r));
		this.newestSessions = this.newestSessions.map(r => new ViewSupplierDashboard(r));
		this.pinnedSessions = this.pinnedSessions.map(r => new ViewSupplierDashboard(r));
	}
}
